export default __webpack_public_path__ + "static/matrix-20a1eebf21a6fe9f0bd1bfbf7c0438d5.gif";